import { getRelatedEntityComponent } from '@unistocks/features/notifications/related-entities/get-related-entity-component';
import { NotificationDto } from '@unistocks/proxy/axios-client';
import { isDefined } from '@unistocks/shared/utils/util';

export type RelatedEntityProps = {
  notification: NotificationDto;
  onComplete: () => void;
};

export const RelatedEntities: React.FC<RelatedEntityProps> = ({ notification, onComplete }) =>
  notification.relatedEntities
    .map(relatedEntity => {
      const Component = getRelatedEntityComponent(relatedEntity.entityName);

      if (!Component) return null;

      return (
        <Component
          key={relatedEntity.id}
          notificationId={notification.id}
          relatedEntity={relatedEntity}
          onComplete={onComplete}
        />
      );
    })
    .filter(isDefined);

RelatedEntities.displayName = 'RelatedEntities';
